import { useState, useEffect, useRef } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import { createPortal } from 'react-dom';
import EcoVideo from 'eco-design/base/eco-video';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import Modal from './Modal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/i18n';

const IButton: React.FC<{
    dataId: string;
    url: string;
    hideUrl: string;
    onChange: () => any;
    active: boolean;
    webpOrJpg: any;
}> = ({ dataId, url, hideUrl, onChange, active, webpOrJpg }) => {
    const [ani, setAni] = useState(true);
    const handleClick = () => {
        setAni(false);
        onChange?.();
    };
    return (
        <div className={`btn-item btn-item-${dataId} ${active ? '' : 'hide'} GtmModuleData-btn-common`} data-btn-id={dataId} onClick={handleClick}>
            <div className="bg" style={{ '--bg-img': `url(${active ? url : hideUrl})` }}></div>
            {ani && <div className="btn"></div>}
            {active && (
                <img className="btn-img" src={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758333020510/btn.svg')} loading="lazy" alt={dataId} />
            )}
        </div>
    );
};

interface ItemType {
    tab: string;
    name: string;
    text: string;
    btn?: string;
    img: string[];
    img2?: string[];
    poster?: string[];
    button?: JSX.Element;
}
const I: React.FC = () => {
    const { t: t2 } = useLang('dpux');
    const { locale } = getLocal();
    const { t } = useLang('dpux');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-I');
    const [isM, setIsM] = useState(false);

    const [active, setActive] = useState(0);
    const [enter, setEnter] = useState({
        btn: false,
    });
    const [modalOpen, setModalOpen] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const [btnActive, setBtnActive] = useState({
        a: true,
        b: true,
        c: true,
    });
    const { a, b, c } = btnActive;
    const imgList = [
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414287911/abc.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421202034/abc.webp',
            flag: !a && !b && !c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760500108655/a.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760500109289/a.webp',
            flag: !a && b && c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760500108883/b.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760500108274/b.webp',
            flag: a && !b && c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414287558/c.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421200935/c.webp',
            flag: a && b && !c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414286227/ab.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421202294/ab.webp',
            flag: !a && !b && c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414286727/ac.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421201759/ac.webp',
            flag: !a && b && !c,
        },
        {
            jpg: 'https://websiteoss.ecoflow.com/upload/image/1760414361532/bc.jpg',
            webp: 'https://websiteoss.ecoflow.com/upload/image/1760421201145/bc.webp',
            flag: a && !b && !c,
        },
    ];

    const changeA = () => {
        setBtnActive({ ...btnActive, a: !btnActive.a });
        gtm.push({
            event: 'uaEvent',
            event_name: 'option_click',
            button_name: 'Light_Intelligent Home Energy Management Hub',
            __btn_id1: `btn-item-Light`,
            __btn_id2: `Light`,
            __btn_type: 'common',
        });
    };
    const changeB = () => {
        setBtnActive({ ...btnActive, b: !btnActive.b });
        gtm.push({
            event: 'uaEvent',
            event_name: 'option_click',
            button_name: 'TV_Intelligent Home Energy Management Hub',
            __btn_id1: `btn-item-TV`,
            __btn_id2: `TV`,
            __btn_type: 'common',
        });
    };
    const changeC = () => {
        setBtnActive({ ...btnActive, c: !btnActive.c });
        gtm.push({
            event: 'uaEvent',
            event_name: 'option_click',
            button_name: 'Water Heater_Intelligent Home Energy Management Hub',
            __btn_id1: `btn-item-Laundry`,
            __btn_id2: `Laundry`,
            __btn_type: 'common',
        });
    };

    const items: ItemType[] = [
        {
            tab: t('I_item1_tab'),
            name: t('I_item1_name'),
            text: t('I_item1_text'),
            btn: t('I_item1_btn'),
            img: [
                webpOrJpg(
                    'https://websiteoss.ecoflow.com/upload/image/1760067792034/I_bg.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1760068515293/I_bg.webp',
                ),
                webpOrJpg(
                    'https://websiteoss.ecoflow.com/upload/image/1760079444979/m_bg.jpg',
                    'https://websiteoss.ecoflow.com/upload/image/1760079446785/m_bg.webp',
                ),
            ],
            button: (
                <>
                    {isM ? (
                        <>
                            <EcoImg
                                className={`btn-d-light ${btnActive.a ? 'hide' : ''}`}
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760079447573/m_lb.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760079447267/m_lb.webp',
                                )}
                            />
                            <EcoImg
                                className={`btn-d-tv ${btnActive.b ? 'hide' : ''}`}
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760079446416/m_rb.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760079446025/m_rb.webp',
                                )}
                            />
                            <EcoImg
                                className={`btn-d-water ${btnActive.c ? 'hide' : ''}`}
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760083531142/m_lt.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760083668496/m_lt.webp',
                                )}
                            />
                        </>
                    ) : (
                        imgList.map((i, idx) => (
                            <EcoImg
                                className={classNames('img-item', {
                                    active: i.flag,
                                })}
                                pc={webpOrJpg(i.jpg, i.webp)}
                                key={idx}
                            />
                        ))
                    )}
                    <div className="phone15">
                        <EcoImg
                            className="phone15-mask"
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1760067792431/I_phone.png',
                                'https://websiteoss.ecoflow.com/upload/image/1760068556685/I_phone.webp',
                            )}
                        />
                        {isM ? (
                            <Swiper className="btn-list" slidesPerView={'auto'} spaceBetween={16}>
                                <SwiperSlide>
                                    <IButton
                                        url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144634/1.png')}
                                        hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144916/1-hide.png')}
                                        dataId="Laundry"
                                        active={btnActive.c}
                                        onChange={changeC}
                                        webpOrJpg={webpOrJpg}
                                    />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <IButton
                                        url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791501010/k2.png')}
                                        hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791396829/g-2.png')}
                                        dataId="TV"
                                        active={btnActive.b}
                                        onChange={changeB}
                                        webpOrJpg={webpOrJpg}
                                    />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <IButton
                                        url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145634/3.png')}
                                        hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145178/3-hide.png')}
                                        dataId="Light"
                                        active={btnActive.a}
                                        onChange={changeA}
                                        webpOrJpg={webpOrJpg}
                                    />
                                </SwiperSlide>
                            </Swiper>
                        ) : (
                            <div className="btn-list">
                                <IButton
                                    url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144634/1.png')}
                                    hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035144916/1-hide.png')}
                                    dataId="Laundry"
                                    active={btnActive.c}
                                    onChange={changeC}
                                    webpOrJpg={webpOrJpg}
                                />
                                <IButton
                                    url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791501010/k2.png')}
                                    hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758791396829/g-2.png')}
                                    dataId="TV"
                                    active={btnActive.b}
                                    onChange={changeB}
                                    webpOrJpg={webpOrJpg}
                                />
                                <IButton
                                    url={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145634/3.png')}
                                    hideUrl={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1761035145178/3-hide.png')}
                                    dataId="Light"
                                    active={btnActive.a}
                                    onChange={changeA}
                                    webpOrJpg={webpOrJpg}
                                />
                            </div>
                        )}
                    </div>
                </>
            ),
        },
        {
            tab: t('I_item2_tab'),
            name: t('I_item2_name'),
            text: t('I_item2_text'),
            btn: t('I_item2_btn'),
            img: ['https://websiteoss.ecoflow.com/upload/video/1760432805393/ats.mp4', 'https://websiteoss.ecoflow.com/upload/video/1760432866037/ats_m.mp4'],
            poster: [
                'https://websiteoss.ecoflow.com/upload/image/1760165004409/ats-pc.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1760165004164/ats-m.jpg',
            ],
        },
    ];

    const handleChangeTab = (e: any, k: number) => {
        setActive(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('I_title'),
            button_name: items[k].tab,
            __btn_id1: `dpux-I .tab-${k + 1}`,
            __btn_id2: items[k].tab,
            __btn_type: 'text',
        });
    };

    const handleOpenModal = () => {
        setModalOpen(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: t('I_title'),
            button_name: t('I_btn'),
            __btn_id1: 'dpux-I .btn',
            __btn_id2: t('I_btn'),
            __btn_type: 'text',
        });
    };

    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
            setIsM(window.innerWidth < 1024);
            const sceneHArr: any[] = [];
            ['btn'].forEach((item: string) => {
                const dom: HTMLElement | null = document.querySelector(`.delta-pro-ultra-x-I .${item}-ani`);
                if (dom) {
                    sceneHArr.push(
                        AniContainer.create({
                            triggerElement: dom,
                            triggerHook: 1,
                            offset: dom?.offsetHeight + 120,
                            duration: window.innerHeight * 1.2,
                            onEnter: () =>
                                setEnter((prev) => ({
                                    ...prev,
                                    [item]: true,
                                })),
                            onLeave: () =>
                                setEnter((prev) => ({
                                    ...prev,
                                    [item]: false,
                                })),
                        }),
                    );
                }
            });

            const label = infoRef.current?.querySelector('.label-ani');
            const title = infoRef.current?.querySelector('.title-ani');
            const desc = infoRef.current?.querySelector('.desc-ani');
            sceneHArr.push(
                AniContainer.create({
                    triggerElement: infoRef.current,
                    triggerHook: 1,
                    offset: '20%',
                    duration: '100%',
                    onEnter: () => {
                        label.classList.add('enter');
                        title.classList.add('enter');
                        desc.classList.add('enter');
                    },
                    onProcess: (process: number) => {
                        if (process <= 0) {
                            label?.classList.remove('enter');
                            title?.classList.remove('enter');
                            desc?.classList.remove('enter');
                        }
                    },
                }),
            );
            return () => {
                sceneHArr.forEach((item) => {
                    item.destroy();
                });
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (active === 1) {
            // 视频
            const video = document.querySelector('.delta-pro-ultra-x-I .imgs .eco-video video') as HTMLVideoElement;
            if (video) {
                video.play();
            }
        } else {
            const video = document.querySelector('.delta-pro-ultra-x-I .imgs .eco-video video') as HTMLVideoElement;
            if (video) {
                setTimeout(() => {
                    video.pause();
                    video.currentTime = 0;
                }, 200);
            }
        }
    }, [active]);

    return (
        <section
            className={`${css.section} delta-pro-ultra-x-I dpux-I GtmModuleData-section`}
            id="delta-pro-ultra-x-I"
            data-section-id={'delta-pro-ultra-x-I'}
            data-section-title={t('I_title')}
        >
            <div className="box">
                <div className="info" ref={infoRef}>
                    <div className="label-ani ani-1">
                        <p className={`label`}>{t('I_label')}</p>
                    </div>
                    <div className="title-ani ani-2">
                        <p className={`title`}>{t('I_title')}</p>
                    </div>
                    <div className="desc-ani ani-3 ">
                        <p className={`desc `}>
                            {t.rich('I_desc', {
                                h: (v: string) => <span className="highlight">{v}</span>,
                                sup: (v: string) => <sup>{v}</sup>,
                            })}
                        </p>
                    </div>
                </div>
            </div>
            <ul className="imgs">
                {items.map((item: ItemType, k: number) => (
                    <li className={`img${k === active ? ' active' : ''}`} key={item.tab}>
                        {item?.img?.every((media: string) => media.endsWith('.mp4')) ? (
                            <EcoVideo pc={item.img[0]} h5={item.img[1]} poster={item?.poster?.[0]} posterH5={item?.poster?.[1]} loop />
                        ) : (
                            <EcoImg className="on bg-img" pc={item.img[0]} h5={item.img[1]} />
                        )}
                        {item?.button}
                    </li>
                ))}
            </ul>

            <div className="wrapper">
                <ul className="tabs">
                    {items.map((item: ItemType, k: number) => (
                        <li
                            className={`tab tab-${k + 1}${k === active ? ' active' : ''} GtmModuleData-btn-text`}
                            key={item.tab}
                            onClick={(e) => handleChangeTab(e, k)}
                        >
                            {item.tab}
                        </li>
                    ))}
                </ul>
                <ul className="contents">
                    {items.map((item: ItemType, k: number) => (
                        <li className={`content${k === active ? ' active' : ''}`} key={item.tab}>
                            <p className="content-name">{item.name}</p>
                            <p className="content-text">{item.text}</p>
                            {locale === 'ca' && <div className="footer-tips mt">{t2('item_Remarks3')}</div>}
                        </li>
                    ))}
                </ul>
                <div className="btn-ani">
                    <span className={`btn GtmModuleData-btn-text${enter.btn ? ' enter' : ''}`} onClick={handleOpenModal}>
                        {t('I_btn')}
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24" fill="none">
                            <path
                                d="M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z"
                                fill="#3F68E0"
                            />
                            <path d="M8.125 12H16.875" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.5 7.625V16.375" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>
            </div>
            {isClient && modalOpen && createPortal(<Modal callback={() => setModalOpen(false)} />, document.body)}
        </section>
    );
};

export default I;
